/**
 * Forgot Password Route
 * Two-panel grid layout matching signin/signout/verf-link
 */

import PubSub from 'pubsub-js';
import AppBroadcast from '../../../../shared/appBroadcast.js';
import CoreRestAPI from '../core/corerest_api.js';
import { MicrocopyManager } from '../../../../shared/meta_microcopy_i18n.js';

export function render() {
  return `
    <div class="auth-container">
      <div class="auth-left">
        <h1 data-meta-copywrite-i118n='{"token": "forgot_password", "attribute": "textContent"}'>Forgot Password</h1>
        <p data-meta-copywrite-i118n='{"token": "enter_email_for_reset", "attribute": "textContent"}'>Please enter your email to receive a password reset link</p>

        <div class="auth-content">
          <form id="forgot-form" class="auth-form" novalidate>
            <div class="form-group">
              <label for="email" data-meta-copywrite-i118n='{"token": "email", "attribute": "textContent"}'>EMAIL</label>
              <input
                type="text"
                id="email"
                name="email"
                placeholder="Enter your email"
                data-meta-copywrite-i118n='{"token": "enter_your_email", "attribute": "placeholder"}'
                autocomplete="email"
              />
            </div>

            <button type="submit" class="btn" data-meta-copywrite-i118n='{"token": "send_reset_link", "attribute": "textContent"}'>SEND RESET LINK</button>
          </form>

          <p class="auth-switch">
            <span data-meta-copywrite-i118n='{"token": "remember_password", "attribute": "textContent"}'>Remember your password?</span> &nbsp; <a class="link-brand--uc__underline" href="#/signin" data-meta-copywrite-i118n='{"token": "sign_in", "attribute": "textContent"}'>SIGN IN</a>
          </p>
        </div>
      </div>

      <div class="auth-right">
        <div class="auth-hero-content">
          <h2>Password Reset</h2>
          <p>
            Enter your email address and we'll send you a link to reset your password.
          </p>
          <p>
            The reset link will be valid for 2 hours.
          </p>
        </div>
      </div>
    </div>

  `;
}

export function init() {
  console.log('[ForgotRoute] Initialized');

  const form = document.getElementById('forgot-form');
  const emailInput = document.getElementById('email');

  // Form submit handler
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();

    const email = emailInput.value.trim();

    // Validate email - stop on first error
    if (!validateEmail(email, emailInput)) return;

    // Proceed with API call
    await handleForgotPassword(email);
  });
}

/**
 * Validate email field - shake and toast on error
 */
function validateEmail(email, inputElement) {
  // Check if empty
  if (!email) {
    shakeAndToast(inputElement, MicrocopyManager.get('validation_email_required'));
    return false;
  }

  // Check format (must contain exactly one @ and at least one .)
  const atCount = (email.match(/@/g) || []).length;
  const dotCount = (email.match(/\./g) || []).length;

  if (atCount !== 1 || dotCount < 1) {
    shakeAndToast(inputElement, MicrocopyManager.get('validation_email_invalid'));
    return false;
  }

  return true;
}

/**
 * Shake element and show toast notification
 */
function shakeAndToast(element, message) {
  // Toast notification
  if (typeof neodigmToast !== 'undefined') {
    neodigmToast.q(message, 'danger');
  }

  // Shake animation
  if (typeof neodigmUtils !== 'undefined') {
    neodigmUtils.shake(`#${element.id}`);
  } else {
    // Fallback if neodigmUtils not available
    element.classList.add('shake');
    setTimeout(() => element.classList.remove('shake'), 300);
  }

  // Focus the invalid field
  element.focus();
}

/**
 * Handle forgot password API call
 */
async function handleForgotPassword(email) {
  const submitBtn = document.querySelector('.btn');
  submitBtn.disabled = true;
  submitBtn.textContent = 'SENDING...';

  try {
    // Call API
    const response = await CoreRestAPI.forgotPassword(email);

    if (response.ok && response.data.ok) {
      // Success
      if (typeof neodigmToast !== 'undefined') {
        neodigmToast.q(MicrocopyManager.get('success_reset_link_sent'), 'success');
      }

      PubSub.publish(AppBroadcast.AUTH_FORGOT_SUCCESS, { email });

      // Navigate to verf-link after 2 seconds
      setTimeout(() => {
        if (window.router) {
          window.router.navigate('/verf-link');
        }
      }, 2000);
    } else {
      // Error from API
      if (typeof neodigmToast !== 'undefined') {
        neodigmToast.q(response.data.error || MicrocopyManager.get('error_signin_failed'), 'danger');
      }
      submitBtn.disabled = false;
      submitBtn.textContent = MicrocopyManager.get('send_reset_link').toUpperCase();
    }
  } catch (error) {
    console.error('[ForgotRoute] Forgot password error:', error);
    if (typeof neodigmToast !== 'undefined') {
      neodigmToast.q(error.message || MicrocopyManager.get('error_network'), 'danger');
    }
    submitBtn.disabled = false;
    submitBtn.textContent = MicrocopyManager.get('send_reset_link').toUpperCase();
  }
}
